<template>
  <section class="closefriend-hero " style="height: 100vh; overflow: hidden;">
    <div class="container-fluid h-100 p-0">
      <div class="row h-100 g-0">
        
        <!-- ======================== -->
        <!-- LEFT PANEL: Thread List  -->
        <!-- ======================== -->
        <div class="col-12 col-md-4 col-lg-3 h-100 flex-column chat-sidebar-panel"
             :class="(selectedCreator && selectedCreator.id) ? 'd-none d-md-flex' : 'd-flex'">
             
          <!-- Header -->
          <div class="p-3 border-bottom border-white-10 chat-sidebar-header">
            <div class="d-flex align-items-center mb-0">
              <span class="cursor-pointer text-white me-3" @click="$router.push({ name: 'CustomerMessageDashboard' })">
                <i class="fa fa-arrow-left"></i>
              </span>
              <h5 class="text-white font-weight-500 mb-0">Messages</h5>
            </div>
          </div>

          <!-- Thread List -->
          <div class="flex-grow-1 overflow-auto" id="content">
            <div v-if="isInboxLoading" class="py-4">
              <div v-for="i in 4" :key="i" class="msg-inbox-row m-2 d-flex align-items-center mb-2" style="border-color: rgba(255,255,255,0.05); cursor: default;">
                <div class="me-3 flex-shrink-0" style="width: 48px; height: 48px; border-radius: 50%; background: rgba(255,255,255,0.05); animation: pulse 1.5s infinite;"></div>
                <div class="flex-grow-1">
                  <div style="height: 14px; background: rgba(255,255,255,0.08); width: 30%; border-radius: 4px; margin-bottom: 8px; animation: pulse 1.5s infinite;"></div>
                  <div style="height: 12px; background: rgba(255,255,255,0.04); width: 60%; border-radius: 4px; animation: pulse 1.5s infinite;"></div>
                </div>
              </div>
            </div>
            <div v-else v-for="(creator, index) in creators" :key="index"
                 class="msg-inbox-row m-2 cursor-pointer"
                 :class="{ 'active': selectedCreator && selectedCreator.id === creator.id, 'unread-thread': isUnread(creator) && (!selectedCreator || selectedCreator.id !== creator.id) }"
                 @click="changeCreator(creator)">
                 <div class="d-flex align-items-center" style="min-width: 0;">
                    <div class="position-relative me-3 flex-shrink-0">
                      <message-avatar :user-id="creator.id"/>
                      <span v-if="isUnread(creator) && (!selectedCreator || selectedCreator.id !== creator.id)" class="msg-unread-dot-badge position-absolute"></span>
                    </div>
                    <div class="flex-grow-1" style="min-width: 0;">
                      <div class="d-flex align-items-center justify-content-between">
                        <span class="font-size-14 text-truncate" 
                              :class="(isUnread(creator) && (!selectedCreator || selectedCreator.id !== creator.id)) ? 'text-white font-weight-700' : 'text-white font-weight-500'" 
                              :title="creator.name || creator.email">
                          {{ creator.name || creator.email }}
                        </span>
                        <span class="font-size-12 ms-2 flex-shrink-0" 
                              :class="(isUnread(creator) && (!selectedCreator || selectedCreator.id !== creator.id)) ? 'text-white font-weight-600' : 'text-muted'" 
                              v-if="creator.lastChat">
                          {{ timeSince(creator.lastChat.sentAt) }}
                        </span>
                      </div>
                      <div class="d-flex align-items-center justify-content-between mt-1" v-if="creator.lastChat">
                        <p class="font-size-12 mb-0 message-preview text-truncate" 
                           :class="(isUnread(creator) && (!selectedCreator || selectedCreator.id !== creator.id)) ? 'text-white font-weight-500' : 'text-muted'" 
                           :title="creator.lastChat.message"
                           :style="(isUnread(creator) && (!selectedCreator || selectedCreator.id !== creator.id)) ? 'opacity: 0.9;' : ''">
                          {{ cropMessage(creator.lastChat) }}
                        </p>
                        <span v-if="isUnread(creator) && (!selectedCreator || selectedCreator.id !== creator.id)" class="msg-unread-badge ms-2">
                          {{ (creator.unreadCount && creator.unreadCount > 0) ? creator.unreadCount : '1' }}
                        </span>
                      </div>
                    </div>
                 </div>
            </div>
          </div>
        </div>

        <!-- ======================== -->
        <!-- RIGHT PANEL: Chat Area   -->
        <!-- ======================== -->
        <div class="col-12 col-md-8 col-lg-9 h-100 flex-column chat-main-panel"
             :class="(selectedCreator && selectedCreator.id) ? 'd-flex' : 'd-none d-md-flex'">
          
          <template v-if="selectedCreator && selectedCreator.id">
            <!-- Chat Header -->
            <div class="p-3 border-bottom border-white-10 d-flex align-items-center justify-content-between chat-header-bar z-index-1">
              <div class="d-flex align-items-center">
                <span class="cursor-pointer text-white me-3 d-md-none" @click="$router.push({ name: 'CustomerMessageDashboard' })">
                  <i class="fa fa-arrow-left"></i>
                </span>
                <message-avatar :user-id="selectedCreator.id" class="me-3"/>
                <div>
                  <h6 class="text-white font-weight-500 mb-0">{{ selectedCreator.name || selectedCreator.email || 'Direct Message' }}</h6>
                </div>
              </div>
            </div>

            <!-- Chat Messages Area -->
            <div class="flex-grow-1 overflow-auto p-3 p-md-4 position-relative" id="content">
              <!-- Thread Loading Spinner -->
              <div v-if="isMessagesLoading && messages.length === 0" class="h-100 d-flex flex-column align-items-center justify-content-center">
                <div class="stella-pulse-spinner mb-3">
                  <div class="stella-pulse-dot"></div>
                  <div class="stella-pulse-dot"></div>
                  <div class="stella-pulse-dot"></div>
                </div>
                <span class="text-white font-size-13" style="opacity: 0.5;">Loading messages...</span>
              </div>

              <template v-else>
                <template v-for="(message, index) in messages">
                  <!-- Unread indicator -->
                  <div v-if="!messages.slice(0, index).some(msg => !msg.read) && !message.read && selectedCreator && message.senderId === selectedCreator.id"
                       class="text-center my-3" :key="'unread-'+index">
                    <span class="badge" style="background: rgba(229, 59, 185, 0.2); color: #E53BB9;">{{ unreadMessagesCount }} Unread messages</span>
                  </div>
                  
                  <div class="d-flex flex-column mb-3" :id="`message_${index}`" :key="message.id || index"
                       :class="(selectedCreator && message.senderId === selectedCreator.id) ? 'align-items-start' : 'align-items-end'">
                    
                    <div :class="(selectedCreator && message.senderId === selectedCreator.id) ? 'chat-bubble-creator' : 'chat-bubble-subscriber'">
                      <span v-if="message.message" v-html="formatMessage(message.message)"></span>
                      
                      <template v-if="message.content && selectedCreator && message.senderId === selectedCreator.id">
                        <div class="mt-2 text-center w-100 position-relative" @dragstart.prevent style="user-select: none; -webkit-touch-callout: none; overflow: hidden; border-radius: 12px;">
                          <template v-if="message.locked">
                            <div class="d-flex flex-column align-items-center justify-content-center cursor-pointer chat-media-attachment" style="background-color: rgba(255, 255, 255, 0.05); border: 2px solid rgba(255,255,255,0.1);" @click="unlockMedia($event, index, message.content.price)">
                              <div style="position: absolute; top: 12px; left: 12px; display: flex; align-items: center; justify-content: center; background-color: rgba(0,0,0,0.6); border-radius: 50%; width: 36px; height: 36px; color: white; z-index: 3;">
                                <i v-if="message.content.type === 'IMAGE'" class="fa fa-image fa-lg"></i>
                                <i v-else-if="message.content.type === 'VIDEO'" class="fa fa-play fa-lg" style="margin-left: 3px;"></i>
                              </div>
                              <img src="@/assets/images/stella/swipe-lock.png" style="-webkit-user-drag: none; width: 64px; margin-bottom: 8px;">
                              <div class="my-2 font-size-18 text-white font-weight-bold" style="z-index: 2;">${{ message.content.price }}</div>
                              <button class="btn rounded-pill text-dark btn-lg px-4 font-weight-bold" style="background: linear-gradient(135deg, #ff6ec7, #f9a826); border: none; z-index: 2;" @click.stop="unlockMedia($event, index, message.content.price)">Unlock</button>
                            </div>
                          </template>
                          <template v-else>
                            <img v-if="message.content.type === 'IMAGE'" @click="unlockMedia($event, index, message.content.price)"
                                 @load="handleMediaLoad"
                                 :src="getContentUrl(message)" alt="" class="chat-media-attachment cursor-pointer" style="-webkit-user-drag: none; -webkit-touch-callout: none; user-select: none;">
                            <video v-else-if="message.content.type === 'VIDEO'" @click="unlockMedia($event, index, message.content.price)"
                                   @loadeddata="handleMediaLoad"
                                   oncontextmenu="return false;" controlsList="nodownload" controls :src="getContentUrl(message)"
                                   class="chat-media-attachment cursor-pointer">
                            </video>
                          </template>
                        </div>
                      </template>
                    </div>
                  </div>
                </template>
              </template>
            </div>

            <!-- AI Disclaimer -->
            <div class="text-center mx-2 mt-2 mb-2 d-flex align-items-center justify-content-center" style="color: #929292; font-size: 13px; width: 100%;">
              <span style="font-size: 15px; margin-right: 8px;">✨</span> May contain AI-generated content
            </div>

            <!-- Chat Input Area -->
            <div class="p-3 border-top border-white-10 chat-input-bar z-index-1">
              <div class="d-flex align-items-end bg-dark-glass p-2 chat-input-container" style="border-radius: 24px;">
                <div ref="messageDiv" class="flex-grow-1 text-white chat-input-editable mx-2 py-2" contenteditable="true"
                     @input="updateMessages" @keydown.enter="handleEnterKey" @paste="handlePaste"
                     placeholder="Type your message..."></div>
                
                <span class="cursor-pointer px-3 py-2" @click="checkToSendMessage()">
                  <i class="fa fa-paper-plane font-size-18 pwa-gradient-icon"></i>
                </span>
              </div>
            </div>
          </template>
          
          <!-- Empty State -->
          <div v-else class="h-100 d-flex flex-column align-items-center justify-content-center">
             <div class="stella-empty-state-icon mb-3">
               <i class="fa fa-comments font-size-32" style="opacity: 0.4; color: #E53BB9;"></i>
             </div>
             <h5 class="text-white font-weight-500 mb-2" style="opacity: 0.6;">Your Messages</h5>
             <p class="text-white font-size-14 mb-0" style="opacity: 0.35;">Select a conversation to start chatting</p>
          </div>
          
        </div>

      </div>
    </div>

    <send-message-modal ref="sendMessageModal" @messageSent="messageSent" @editMessage="editMessage" />
    <unlock-media-message-modal ref="unlockMediaMessageModal" @unlockedMessage="unlockMediaNow" />
    <model-image-view ref="imageView" />
    <model-video-view ref="videoView" />
  </section>
</template>
<script>
import { httpMixin } from "@/mixin/http-mixin";
import { mapActions, mapGetters } from "vuex";
import { SERVICE_CONTENT, SERVICE_DIRECT_MESSAGE, SERVICE_PAYMENT } from "@/properties/micro-service";
import SendMessageModal from "@/components/module/customer/direct-message/SendMessageModal";
import UnlockMediaMessageModal from "@/components/module/customer/direct-message/UnlockMediaMessageModal";
import ModelImageView from "@/components/module/shared/ModelImageView";
import ModelVideoView from "@/components/module/shared/ModelVideoView";
import { CONTENT_TYPE_IMAGE, CONTENT_TYPE_VIDEO } from "@/properties/content-type";
import { cropMessage, scroll } from "@/common/Utils";
import GlobalMessage from "@/components/module/shared/GlobalMessage";
import { BONUS_CONTENT, MESSAGE, paymentCancelled, paymentPaid } from "@/common/analytics-service";

import '@/assets/styles/direct-message/direct-message-common.css'
import { timeSince } from "@/common/datetime-service";
import MessageAvatar from "@/components/module/shared/direct-message/MessageAvatar";

export default {
  name: "CustomerDirectMessage",
  mixins: [httpMixin],
  components: {
    MessageAvatar,
    GlobalMessage,
    SendMessageModal,
    UnlockMediaMessageModal,
    ModelImageView,
    ModelVideoView
  },
  data() {
    let initialCreator = {};
    if (this.$route && this.$route.params && this.$route.params.customerId) {
      initialCreator = { id: parseInt(this.$route.params.customerId) };
    } else if (this.$route && this.$route.query && this.$route.query.inf) {
      initialCreator = { id: parseInt(this.$route.query.inf) };
    } else {
      const stored = localStorage.getItem('selectedCreatorId');
      if (stored) {
        initialCreator = { id: parseInt(stored) };
      }
    }

    return {
      creators: [],
      selectedCreator: initialCreator,
      message: null,
      pollInterval: null,
      messages: [],
      draftMessage: null,
      messageSetting: null,
      inboxCount: 0,
      showSlideBar: false,
      unreadMessagesCount: 0,
      isUnlocked: false,
      isUnlockedVideo: false,
      isInboxLoading: false,
      isMessagesLoading: false,
    }
  },
  computed: {
    ...mapGetters(['getUser']),
    isfirstMessageFree() {
      const currentUserId = this.getUser ? this.getUser.id : null;
      let exists = currentUserId ? this.messages.some(msg => msg.senderId === currentUserId) : false;
      if (this.messageSetting && this.messageSetting.firstMessageFree && !exists) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    message(newMessage) {
      if (this.$refs && this.$refs.messageDiv) {
        const currentText = this.$refs.messageDiv.innerText ? this.$refs.messageDiv.innerText.replace(/\r\n/g, '\n') : '';
        const normalizedNew = (newMessage || '').replace(/\r\n/g, '\n');
        if (currentText !== normalizedNew && (currentText === '\n' ? '' : currentText) !== normalizedNew) {
          this.$refs.messageDiv.innerText = newMessage || '';
        }
      }
    },
    getUser: {
      immediate: true,
      handler(user) {
        if (user && user.id) {
          if (!this.creators || this.creators.length === 0) {
            this.getCreators();
          }
          if (this.selectedCreator && this.selectedCreator.id && (!this.messages || this.messages.length === 0)) {
            this.getMessages(true);
            this.getDraftMessage();
            this.getMessageSetting();
          }
        }
      }
    }
  },
  created() {
    const status = this.$route.query.status;
    const clientReferenceId = this.$route.query.clientReferenceId;

    if (this.selectedCreator && this.selectedCreator.id) {
      this.getMessages(true);
      this.getDraftMessage();
      this.getMessageSetting();
    }

    if (status === 'success') {
      this.setMessage('MESSAGE.SENT');
      paymentPaid(this, MESSAGE, this.getPayInfluencer());
      this.draftMessage = {};
      this.message = '';
      if (this.$refs.messageDiv) {
        this.$refs.messageDiv.innerText = '';
      }
      if (clientReferenceId) {
        let URL = `${SERVICE_PAYMENT}/api/v1/stripe/transactions/${clientReferenceId}`;
        this.putData(URL, {}, (data) => {
          this.draftMessage = {};
          this.message = '';
          if (this.$refs.messageDiv) {
            this.$refs.messageDiv.innerText = '';
          }
          this.getCreators();
        }, (error) => {
          this.getCreators();
        });
      } else {
        this.getCreators();
      }
    } else if (status === 'cancelled') {
      this.setWarning('Payment was cancelled. You can retry sending your message whenever you\'re ready.');
      if (clientReferenceId) {
        let URL = `${SERVICE_PAYMENT}/api/v1/stripe/checkout/cancel/${clientReferenceId}`;
        this.postUnsecureData(URL, {}, (data) => {
        });
      }
      paymentCancelled(this, MESSAGE, this.getPayInfluencer());
      this.getCreators();
    } else if (status === 'failure') {
      this.pushGlobalError('Payment failed. Please try again.');
      this.getCreators();
    } else {
      this.getCreators();
    }

    // Clean query parameters from URL without remounting the component
    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  },

  mounted() {
    this.pollInterval = setInterval(() => {
      if (typeof document !== 'undefined' && document.hidden) {
        return;
      }
      this.getMessages();
    }, 6000)
  },
  destroyed() {
    clearInterval(this.pollInterval);
    localStorage.removeItem('selectedCreatorId');
  },
  methods: {
    ...mapActions(['setMessage', 'setWarning', 'pushGlobalError']),
    ...mapGetters(['getPayInfluencer']),
    isUnread(creator) {
      if (!creator) return false;
      if (creator.unreadCount && creator.unreadCount > 0) return true;
      const currentUserId = this.getUser ? this.getUser.id : null;
      return !!(creator.lastChat && (!creator.lastChat.read && creator.lastChat.senderId !== currentUserId));
    },
    getContentUrl(message) {
      return message.content.cdnUrl;
    },
    cropMessage,
    timeSince,
    getMessageSetting() {
      if (!this.selectedCreator || !this.selectedCreator.id) return;
      let receiverId = this.selectedCreator.id;
      let url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/message-settings/influencers/${receiverId}`;
      this.getData(url, (messageSetting) => {
        this.messageSetting = messageSetting;
      }, (err) => {}, true);
    },
    getCreators(disableLoading = false) {
      if (!this.getUser || !this.getUser.id) {
        this.isInboxLoading = false;
        return;
      }
      this.isInboxLoading = true;
      let url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/chat-messages/customers/${this.getUser.id}/senders`;
      this.getData(url, (creators) => {
        this.isInboxLoading = false;
        this.creators.splice(0);
        this.creators.push(...creators);
        if (this.creators.length > 0) {
          const storedSubscriberId = localStorage.getItem('selectedCreatorId');

          if (this.$route.params.customerId) {
            let index = creators.findIndex(e => e.id == this.$route.params.customerId);
            this.selectedCreator = (index !== -1 ? creators[index] : creators[0]) || {};
          } else if (this.$route.query.inf) {
            let index = creators.findIndex(e => e.id == this.$route.query.inf);
            this.selectedCreator = (index !== -1 ? creators[index] : creators[0]) || {};
          } else if (storedSubscriberId) {
            let selectedIndex = creators.findIndex((sub) => sub.id === parseInt(storedSubscriberId));
            this.selectedCreator = (selectedIndex !== -1 ? creators[selectedIndex] : creators[0]) || {};
          } else if (!this.selectedCreator || !this.selectedCreator.id) {
            this.selectedCreator = creators[0] || {};
          } else {
            let matchIndex = creators.findIndex(c => c.id === this.selectedCreator.id);
            if (matchIndex !== -1) {
              this.selectedCreator = creators[matchIndex];
            }
          }

          this.getDraftMessage();
          this.getMessages(true);
          this.getMessageSetting();
          this.getCreatorsLatestMessage();
        }
      }, (err) => {
        this.isInboxLoading = false;
      }, disableLoading);
    },
    getCreatorsLatestMessage() {
      if (!this.getUser || !this.getUser.id) return;
      let url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/chat-messages/customers/${this.getUser.id}/latest`;
      this.getData(url, (lastChatData) => {
        let lastChats = lastChatData.chatMessages ? lastChatData.chatMessages : [];
        this.inboxCount = lastChatData.unreadMessageCount;
        lastChats.forEach((lastChat) => {
          let index = this.creators.findIndex((sub) => sub.id === lastChat.senderId || sub.id === lastChat.receiverId);
          if (index !== -1) {
            let creator = this.creators[index];
            creator.lastChat = lastChat;
            this.$set(this.creators, index, creator);
          }
          if (this.$route.query.msgId) {
            let index = this.messages.findIndex(e => e.id == this.$route.query.msgId);
            if (index !== -1 && this.messages[index] && this.messageSetting) {
              this.showUnlockMediaModal(this.messages[index], this.messageSetting.pricePerFile);
            }
          } else if (this.$route.query.inf) {
            this.showSendMsgModal(this.draftMessage);
          }
        });
      }, (err) => {}, true);
    },
    getDraftMessage() {
      if (!this.selectedCreator || !this.selectedCreator.id || !this.getUser || !this.getUser.id) return;
      let receiverId = this.selectedCreator.id;
      let url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/chat-messages/customers/${this.getUser.id}/draft/${receiverId}`;
      this.getData(url, (draftMessage) => {
        this.draftMessage = draftMessage;
        if (this.draftMessage && this.draftMessage.status === 'D') {
          this.message = this.draftMessage.message || '';
        } else if (this.$route.query.draft) {
          this.message = this.$route.query.draft;
        } else {
          this.message = '';
          this.draftMessage = null;
        }
        if (this.$refs.messageDiv) {
          this.$refs.messageDiv.innerText = this.message || '';
        }
      }, (err) => {}, true);
    },
    getMessages(isSubChanged) {
      if (!this.selectedCreator || !this.selectedCreator.id || !this.getUser || !this.getUser.id) {
        this.isMessagesLoading = false;
        return;
      }
      let receiverId = this.selectedCreator.id;
      let url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/chat-messages/customers/${this.getUser.id}/receiver/${receiverId}`;
      if (this.messages.length === 0) {
        this.isMessagesLoading = true;
      }
      this.getData(url, (messages) => {
        this.isMessagesLoading = false;
        if (this.messages.length !== messages.length || isSubChanged) {
          this.messages = messages;
          this.handleScrollToMessage(!!isSubChanged);
          this.markAsRead();
        }
      }, (err) => {
        this.isMessagesLoading = false;
      }, true);
    },
    handleMediaLoad() {
      this.handleScrollToMessage();
    },
    handleScrollToMessage(force = false) {
      const currentUserId = this.getUser ? this.getUser.id : null;
      const unreadMessages = this.messages.filter(message => !message.read && message.senderId !== currentUserId);
      this.unreadMessagesCount = unreadMessages.length;

      const chatContainer = this.$el && this.$el.querySelector('#content');
      if (chatContainer && !force) {
        const isNearBottom = chatContainer.scrollHeight - chatContainer.scrollTop - chatContainer.clientHeight < 150;
        if (!isNearBottom) {
          return;
        }
      }

      if (this.unreadMessagesCount > 0 && force) {
        let unreadIndex = this.messages.findIndex(message => !message.read && message.senderId !== currentUserId);
        this.scrollToMessage(unreadIndex, { block: "center" });
      } else {
        this.scrollToMessage(this.messages.length - 1);
      }
    },
    markAsRead() {
      if (!this.getUser || !this.getUser.id) return;
      let messageIds = this.messages.filter((msg) => msg.receiverId === this.getUser.id && !msg.read).map(e => e.id);
      let url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/chat-messages/customers/${this.getUser.id}/read/${messageIds}`;
      if (messageIds.length > 0) {
        this.messages.forEach(m => {
          if (messageIds.includes(m.id)) {
            m.read = true;
          }
        });
        this.postData(url, {}, (data) => {
          this.creators.forEach(subscriber => {
            if (subscriber.lastChat) {
              if (subscriber.lastChat.read === false) {
                subscriber.lastChat.read = true;
              }
            }
          });
        }, null, true);
      }
    },
    showMediaPreview(content) {
      if (content.type === CONTENT_TYPE_IMAGE && content.cdnUrl) {
        this.$refs.imageView.show(content.cdnUrl, this.getUser);
      } else if (content.type === CONTENT_TYPE_VIDEO && content.cdnUrl) {
        this.$refs.videoView.show(content.cdnUrl);
      }
    },
    changeCreator(creator) {
      this.selectedCreator = creator;
      this.messages = [];
      this.message = '';
      this.draftMessage = null;
      if (this.$refs && this.$refs.messageDiv) {
        this.$refs.messageDiv.innerText = '';
      }
      if (creator && creator.id) {
        localStorage.setItem('selectedCreatorId', creator.id);
      }
      this.getMessages(true);
      this.getDraftMessage();
      this.getMessageSetting();
    },
    checkToSendMessage() {
      const trimmedMessage = this.message ? this.message.trim() : '';
      if (!trimmedMessage) return;
      this.message = trimmedMessage;

      if (this.message.length > 500) {
        this.setWarning('Message exceeds 500 characters limit!');
        return;
      }
      if (this.messageSetting && this.messageSetting.pricePerMessage > 0 && !this.isfirstMessageFree) {
        if (this.draftMessage && this.draftMessage.id && this.draftMessage.status === 'D') {
          this.updateMessage((draftMessage) => {
            this.showSendMsgModal(draftMessage);
          });
        } else {
          this.sendMessage('D', (draftMessage) => {
            this.draftMessage = draftMessage;
            this.showSendMsgModal(draftMessage);
          });
        }
      } else {
        if (this.draftMessage && this.draftMessage.id && this.draftMessage.status === 'D') {
          this.draftMessage.status = 'S';
          this.updateMessage((_) => {
          });
        } else {
          this.sendMessage('S', (_) => {
          });
        }
      }
    },
    showSendMsgModal(draftMessage) {
      let influencerId = this.selectedCreator.id;
      let customerid = this.getUser.id;
      let msgPrice = this.messageSetting.pricePerMessage;
      this.$refs.sendMessageModal.show(influencerId, customerid, draftMessage, msgPrice);
    },
    editMessage() {
    },
    messageSent(sentMessage) {
      this.message = '';
      this.draftMessage = null;
      if (this.$refs.messageDiv) {
        this.$refs.messageDiv.innerText = '';
      }
      let index = this.messages.findIndex((msg) => msg.id === sentMessage.id);
      this.setMessage('MESSAGE.SENT');
      //If not found then push the new message. It can be so, that the msg was loaded by polling
      if (index === -1) {
        this.messages.push(sentMessage);
      } else {
        this.$set(this.messages, index, sentMessage);
      }
      this.scrollToMessage(this.messages.length - 1);
      this.getDraftMessage();
      this.getCreatorsLatestMessage();
    },
    // unlockMedia(event, index) {
    //
    //   if (this.messages[index].content.price > 0 && this.messages[index].locked) {
    //     this.showUnlockMediaModal(this.messages[index]);
    //   } else {
    //     if (!this.isMobile()) {
    //       //If not mobile prevent the video in the background from playing.
    //       // We want only the video in model to play
    //       event.preventDefault();
    //     }
    //     this.showMediaPreview(this.messages[index].content);
    //     this.$set(this.messages[index], 'isUnlocked', true);
    //   }
    // },
    unlockMedia(event, index, msgPrice) {
      if (this.messages[index].content.price > 0 && this.messages[index].locked) {
        this.showUnlockMediaModal(this.messages[index], msgPrice);
        this.$set(this.messages[index], 'isUnlocked', true);
        this.$set(this.messages[index], 'isUnlockedVideo', true);
      } else {
        if (!this.isMobile()) {
          // If not mobile, prevent the video in the background from playing
          event.preventDefault();
        }
        this.showMediaPreview(this.messages[index].content);

        // Ensure reactivity with Vue.set


      }
    },

    showUnlockMediaModal(message, msgPrice) {
      let influencerId = this.selectedCreator.id;
      let customerId = this.getUser.id;
      let finalPrice = (message.content && message.content.price) ? message.content.price : this.messageSetting.pricePerFile;
      this.$refs.unlockMediaMessageModal.show(influencerId, customerId,
        message, finalPrice);
    },
    unlockMediaNow(unlockedMessage) {
      let index = this.messages.findIndex((msg) => msg.id === unlockedMessage.id);
      this.messages[index].locked = false;
      this.messages[index].content.cdnUrl = unlockedMessage.content.cdnUrl;
      this.setMessage('UNLOCKED.MEDIA');
      this.scrollToMessage(this.messages.length - 1);
    },
    sendMessage(status, fn) {
      if (!this.getUser || !this.getUser.id || !this.selectedCreator || !this.selectedCreator.id) return;
      let chatMessage = {
        "message": this.message,
        "senderId": this.getUser.id,
        "receiverId": this.selectedCreator.id,
        "contentId": null,
        "status": status,
        "locked": false,
        "read": false
      };
      let url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/chat-messages/customers/${this.getUser.id}`;
      this.postData(url, chatMessage, (message) => {
        fn(message);
        if (status === 'S') {
          this.message = '';
          this.draftMessage = null;
          if (this.$refs.messageDiv) {
            this.$refs.messageDiv.innerText = '';
          }
          this.messages.push(message);
          this.scrollToMessage(this.messages.length - 1);
          this.getDraftMessage();
          this.getCreatorsLatestMessage();
        }
      });
    },
    updateMessage(fn) {
      if (!this.getUser || !this.getUser.id || !this.draftMessage) return;
      this.draftMessage.message = this.message;
      let url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/chat-messages/customers/${this.getUser.id}`;
      this.patchData(url, this.draftMessage, (draftMessage) => {
        this.draftMessage = draftMessage;
        fn(draftMessage);
      });
    },
    scrollToMessage(num, options = {}) {
      if (num === -1) {
        return;
      }
      this.$nextTick(() => {
        const element = document.getElementById(`message_${num}`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'end', ...options });
        }
      });
    },
    slideBar() {
      this.showSlideBar = !this.showSlideBar;
    },
    formatMessage(message) {
      if (message) {
        const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])|(\b(www\.[\S]+))/gi;
        const formatted = message.replace(urlPattern, url => {
          const href = url.startsWith('www.') ? `http://${url}` : url;
          return `<a href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>`;
        });
        return formatted.replace(/\n/g, '<br>');
      } else {
        return 'N/A';
      }
    },
    handleEnterKey(event) {
      if (event.shiftKey) {
        return;
      } else {
        event.preventDefault();
        this.checkToSendMessage();
      }
    },
    updateMessages(event) {
      const div = event.target;
      if (div) {
        const text = div.innerText ? div.innerText.replace(/\r\n/g, '\n') : '';
        this.message = text === '\n' ? '' : text;
      }
    },
    handlePaste(event) {
      event.preventDefault();
      const text = (event.clipboardData || window.clipboardData).getData('text/plain');
      document.execCommand('insertText', false, text);
    },
  }
}
</script>
<style>
@media only screen and (max-width: 767px) {
  .chat-input-textarea-class {

    height: 8vh;
    width: 100%;
    position: fixed;
    bottom: 0;
    overflow: auto;
    background: #000;
  }

  .chat-width-fix {
    height: 4vh;
    width: 66% !important;
  }
}

@media only screen and (min-width:768px)and (max-width: 1024px) {
  .chat-input-textarea-class {

    height: 8vh;
    width: 85%;
    position: fixed;
    bottom: 0;
    overflow: auto;
    background: #000;
  }

  .chat-width-fix {
    height: 4vh;
    width: 78% !important;
  }
}

@media only screen and (min-width: 1025px) {
  .chat-input-textarea-class {

    height: 8vh;
    width: 90%;
    position: fixed;
    bottom: 0;
    overflow: auto;
    background: #000;
  }

  .chat-width-fix {
    height: 4vh;
    width: 78% !important;
  }
}

.left-side-class {
  position: absolute;
  top: 14vh;
  height: 86vh;
  left: 0rem !important;
  overflow: auto;
  margin-bottom: 0rem !important;
  padding-bottom: 1rem !important;
}

.right-side-class {
  position: absolute;
  top: 14vh;
  height: 86vh;
  right: 0rem !important;
  overflow: hidden !important;
}

.chat-header-customer {
  height: 8vh !important;
  position: relative !important;
  top: 0 !important;
}

.chat-content-customer {
  overflow: auto !important;
  height: 67vh !important;
  position: relative !important;
  margin-top: 1rem !important;
}

@media screen and (max-width: 576px) {
  .chat-header-customer {
    height: 8vh !important;
    position: relative !important;
    top: 0 !important;
  }

  .chat-content-customer {
    overflow: auto !important;
    height: 67vh !important;
    position: relative !important;
    margin-top: 1rem !important;
  }
}

@media screen and (min-width: 576px) and (max-width: 768px) {
  .chat-header-customer {
    height: 7vh !important;
    position: relative !important;
    top: 0 !important;
  }

  .chat-content-customer {
    overflow: auto !important;
    height: 68vh !important;
    position: relative !important;
    margin-top: 1rem !important;
  }
}

@media screen and (min-width: 768px) and (max-width: 992px) {
  .chat-header-customer {
    height: 7vh !important;
    position: relative !important;
    top: 0 !important;
  }

  .chat-content-customer {
    overflow: auto !important;
    height: 68vh !important;
    position: relative !important;
    margin-top: 1rem !important;
  }
}

@media screen and (min-width: 992px) and (max-width: 1200px) {
  .chat-header-customer {
    height: 7vh !important;
    position: relative !important;
    top: 0 !important;
  }

  .chat-content-customer {
    overflow: auto !important;
    height: 68vh !important;
    position: relative !important;
    margin-top: 1rem !important;
  }
}

@media screen and (min-width: 1200px) and (max-width: 1400px) {
  .chat-header-customer {
    height: 7vh !important;
    position: relative !important;
    top: 0 !important;
  }

  .chat-content-customer {
    overflow: auto !important;
    height: 68vh !important;
    position: relative !important;
    margin-top: 1rem !important;
  }
}

@media screen and (min-width: 1400px) {
  .chat-header-customer {
    height: 7vh !important;
    position: relative !important;
    top: 0 !important;
  }

  .chat-content-customer {
    overflow: auto !important;
    height: 68vh !important;
    position: relative !important;
    margin-top: 1rem !important;
  }

  a {
    color: #007bff;
    text-decoration: underline;
  }

  a:hover {
    color: #0056b3;
  }

  .custom-div {
    resize: none;
    overflow: hidden;
    height: auto;
    min-height: 40px;
    max-height: 50px;
    box-sizing: border-box;
    padding: 10px;
    border-radius: 50px;
    background-color: #333;
    color: white;
    font-size: 16px;
    font-family: inherit;
    line-height: 1.5;
  }
}

.dynamic-border{
  border: 2px solid transparent !important;
  background-image: linear-gradient(#fff, #fff 0), linear-gradient(90deg, #36d1dc, #5b86e5) !important; /* New gradient */
}

/* --- NEW CLEAN UI STYLES --- */
.bg-dark-transparent {
    background: rgba(17, 17, 17, 0.95);
}

.bg-dark-glass {
    background: rgba(255, 255, 255, 0.05);
}

.border-white-10 {
    border-color: rgba(255, 255, 255, 0.1) !important;
}

.msg-inbox-row {
    padding: 12px;
    border-radius: 12px;
    transition: all 0.2s ease;
    background: transparent;
}

.msg-inbox-row:hover {
    background: rgba(255, 255, 255, 0.05);
}

.msg-inbox-row.active {
    background: rgba(255, 255, 255, 0.08);
    box-shadow: inset 3px 0 0 #E53BB9;
}

.msg-inbox-row.unread-thread {
    background: rgba(229, 59, 185, 0.08) !important;
    border: 1px solid rgba(229, 59, 185, 0.3) !important;
    box-shadow: inset 3px 0 0 #E53BB9;
}

.msg-unread-dot-badge {
    top: -2px;
    right: -2px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: linear-gradient(135deg, #F3DA6B, #E53BB9);
    border: 2px solid #111;
    box-shadow: 0 0 6px rgba(229, 59, 185, 0.8);
}

.msg-new-badge {
    background: #55EFC4;
    color: #000;
    padding: 2px 6px;
    font-size: 10px;
    font-weight: 600;
    border-radius: 4px;
}

.msg-unread-badge {
    background: linear-gradient(135deg, #E53BB9, #ff6ec7);
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    padding: 2px 8px;
    border-radius: 12px;
    min-width: 20px;
    text-align: center;
    flex-shrink: 0;
    box-shadow: 0 2px 8px rgba(229, 59, 185, 0.4);
}

.msg-unread-dot {
    width: 8px;
    height: 8px;
    background: #E53BB9;
    border-radius: 50%;
    display: inline-block;
}

.chat-bubble-subscriber {
    background: linear-gradient(135deg, #F3DA6B 0%, #E53BB9 100%);
    color: white;
    padding: 12px 16px;
    border-radius: 16px 16px 4px 16px;
    max-width: 75%;
    font-size: 14px;
    line-height: 1.5;
    word-break: break-word;
}

.chat-bubble-creator {
    background: #2A2A2A;
    color: white;
    padding: 12px 16px;
    border-radius: 16px 16px 16px 4px;
    max-width: 75%;
    font-size: 14px;
    line-height: 1.5;
    word-break: break-word;
}

.chat-media-attachment {
    width: 220px;
    height: 220px;
    object-fit: cover;
    border-radius: 12px;
}

.chat-input-editable {
    min-height: 24px;
    max-height: 120px;
    overflow-y: auto;
    outline: none;
    line-height: 1.5;
    word-break: break-word;
    font-size: 14px;
}

.chat-input-editable:empty:before {
    content: attr(placeholder);
    color: rgba(255, 255, 255, 0.4);
    pointer-events: none;
}

.hover-pink {
    transition: color 0.2s ease;
}

.hover-pink:hover {
    color: #E53BB9 !important;
}


.stella-empty-state-icon {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: rgba(229, 59, 185, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
}

.z-index-1 {
    z-index: 1;
}
</style>
